<template>
  <li class="notefie-dashboard__nav-item second-lvl">
    <a
      class="second-lvl-nav-link"
      :href="`#${refer}`"
      @click="toggleCollapsed"
      :aria-expanded="isExpanded ? 'true' : 'false'"
    >
      <span> <slot></slot> </span>
      <span class="mx-3 pl-1 text-white">
        {{ text }}
      </span>
      <span class="chevron-icon">
        <ChevronDown />
      </span>
    </a>
    <div :id="refer" :class="['collapse', { show: isExpanded }]">
      <ul class="child2 flex-column">
        <slot name="nav-child-item" />
      </ul>
    </div>
  </li>
</template>

<script setup lang="ts">
import { ChevronDown } from '@vicons/fa'
import { useRoute } from 'vue-router'
import { onMounted, watch, ref } from 'vue'

interface SideNavCollapseProps {
  refer: string
  miniIcon: string
  text: string
  activePaths?: string[]
}

const props = defineProps<SideNavCollapseProps>()
const route = useRoute()
const isExpanded = ref(false)

function shouldExpand(pathname: string): boolean {
  if (!props.activePaths || props.activePaths.length === 0) return false
  return props.activePaths.some((p) => !!p && pathname.startsWith(p))
}

function syncExpanded() {
  isExpanded.value = shouldExpand(route.path)
}

onMounted(() => {
  syncExpanded()
})

watch(
  () => route.path,
  () => {
    syncExpanded()
  }
)

const toggleCollapsed = () => {
  isExpanded.value = !isExpanded.value
}
</script>

<style lang="scss">
.notefie-dashboard__nav-item.second-lvl {
  & .second-lvl-nav-link {
    @apply relative;
    & .chevron-icon svg {
      @apply absolute;
      width: 11px;
      right: 13px;
      top: 16px;
      transition: all 0.2s ease-in-out;
    }
    &[aria-expanded='true'] {
      margin-bottom: 0.5rem;
      & .chevron-icon svg {
        transform: rotate(180deg);
      }
    }
    &:hover {
      background-color: #585858;
    }
  }
}

.child2 {
  margin-left: 20px;
}
</style>
